import type { TNotesType } from "components/Dashboard/DoctorDashboard/notes-and-forms/types";
import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";
import getNoteOrFormSchemaDB from "./utils/getNoteOrFormSchemaDB";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export default async function deleteNoteOrFormSchema<T extends TNotesType>(
  type: T,
  schemaId: string,
) {
  const res = await fetchOrchidAPI(
    `/api/${getNoteOrFormSchemaDB(type)}/v1/${type}s/schema/${schemaId}`,
    {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
    },
  );

  if (!res.ok) {
    throw new Error(
      `failed to update ${type} schema: ${getErrorDetail(await res.text())}`,
    );
  }

  return;
}

export const useDeleteSchemaMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: { type: TNotesType; schemaId: string }) =>
      deleteNoteOrFormSchema(payload.type, payload.schemaId),
    onSuccess: (_data, variables) => {
      switch (variables.type) {
        case "note":
          queryClient.invalidateQueries({ queryKey: ["note-schema"] });
          break;
        case "form":
          queryClient.invalidateQueries({ queryKey: ["form-schema"] });
          break;
      }
    },
  });
};
